export default "__VITE_ASSET__DCsspf2F__"